export default {
  items: [
    {
      name: 'Dashboard',
      url: '/beta/admin/dashboard',
      icon: 'fa fa-th-large'
    },
    {
      name: 'Catalog Management',
      url: '/beta/admin/product',
      icon: 'fa fa-inbox'
    },
    {
      name: 'Users',
      url: '/beta/admin/user',
      icon: 'fa fa-user'
    },
    {
      name: 'Customers',
      url: '/beta/admin/customer',
      icon: 'fa fa-address-book'
    },
    {
      name: 'Subscribers',
      url: '/beta/admin/subscribers',
      icon: 'fa fa-feed'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/admin/_nav.js